export class AFetchError<T = any> extends Error {
	status: number;
	data: T;

	constructor(data: T, status: number) {
		super();
		this.status = status;
		this.data = data;
	}
}

/**
 * Wrapper natywnego fetch'a, zwracane dane są parsowane jeśli są valid JSON'em, funkcja throwuje wyjątki typu AFetchError jeśli status !== 200 lub coś pójdzie nie tak; wyjątki należy obsłuzyć samemu
 * @param url URL dla requesta
 * @param options opcje, te same co w zwykłym fetch'u + errorDataKey - pole określające skąd brać zwracane dane dla obiektu błędu
 * @returns odnaleziony zasób jako obiekt
 */
export const aFetch = async <T, P = any>(
	mode: 'GET' | 'POST',
	url: string,
	options?: RequestInit & { errorDataKey?: string; _body?: P }
) => {
	const { _body, errorDataKey, ...fetchOptions } = options || {};

	const res = await fetch(url, {
		...fetchOptions,
		method: mode,
		credentials: 'include',
		body: mode !== 'GET' && _body ? JSON.stringify(_body) : undefined,
		headers: {
			'Content-Type': 'application/json',
			...fetchOptions.headers,
		},
	});

	const hasJSONBody = res.headers
		.get('Content-Type')
		?.includes('application/json');

	if (!hasJSONBody) {
		throw new AFetchError(undefined, res.status);
	}

	const JSONBody = await res.json();

	if (res.status !== 200) {
		const errorData = errorDataKey ? JSONBody[errorDataKey] : JSONBody;
		throw new AFetchError(errorData, res.status);
	}

	return JSONBody as T;
};